module.exports = __webpack_public_path__ + "img/volets-roulants.b223f9df.svg";